import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { constants } from "@cinch-nx/data-search";
var defaultFilters = constants.defaultFilters, defaultNonFilterParams = constants.defaultNonFilterParams;
var defaultParams = _object_spread({}, defaultFilters, defaultNonFilterParams);
export function convertSearchFiltersToQueryParams(filters, allCinchStores) {
    var urlParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(filters)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            if (key === "store" && Array.isArray(value) && value.length === 1 && (allCinchStores === null || allCinchStores === void 0 ? void 0 : allCinchStores.length) === 1 && allCinchStores[0] === value[0]) {
                urlParams.set("store", "all-stores");
            } else if (Array.isArray(value) && value.length > 0) {
                urlParams.set(key, value.join(","));
            } else if (value !== defaultParams[key]) {
                urlParams.set(key, "".concat(value));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return urlParams;
}
